/* Ficha de producto: "Agregar al carrito" suma sin salir de la pagina y abre el cajon lateral; "Comprar ahora" va directo a pagar (return_to=/checkout). /cart no se usa (redirige al inicio), por eso el formulario ya no puede volver a /cart. Ojo: el formulario tiene un campo llamado id, asi que form.id devuelve ese campo; se usa getAttribute('id'). */
(function(){
  if(window.__bjBuy)return;window.__bjBuy=1;
  function refreshDrawer(){
    var cur=document.querySelector('#shopify-section-cart-drawer-section');
    if(!cur)return Promise.resolve();
    return fetch('/?sections=cart-drawer-section',{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(j){
      var d=new DOMParser().parseFromString(j['cart-drawer-section']||'','text/html');
      var n=d.querySelector('#shopify-section-cart-drawer-section');
      if(n)cur.innerHTML=n.innerHTML;
    }).catch(function(){});
  }
  document.addEventListener('submit',function(e){
    var f=e.target;
    if(!f||!f.getAttribute||f.getAttribute('id')!=='bjpdp-form')return;
    var s=e.submitter;
    if(s&&s.name==='checkout'){var r=f.querySelector('input[name=return_to]');if(r)r.value='/checkout';return}
    e.preventDefault();
    var btn=f.querySelector('[data-add]');
    if(!btn||btn.disabled)return;
    var label=btn.textContent;
    var id=parseInt(f.querySelector('input[name=id]').value,10);
    var qi=f.querySelector('[data-qty-input]');
    var qty=qi?parseInt(qi.value,10)||1:1;
    var root=f.closest('[data-bjpdp]');
    btn.disabled=true;btn.textContent='Agregando…';
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty}]})})
      .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
      .then(function(){return fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json()})})
      .then(function(c){
        var ci=document.querySelector('cart-icon');
        if(ci&&typeof ci.renderCartBubble==='function')ci.renderCartBubble(c.item_count);
        if(root&&root._refreshCart)root._refreshCart();
        return refreshDrawer();
      })
      .then(function(){
        btn.textContent='Agregado ✓';btn.classList.add('ok');
        var dr=document.querySelector('#cart-drawer');
        if(dr&&typeof dr.open==='function')dr.open();
        setTimeout(function(){btn.disabled=false;btn.classList.remove('ok');btn.textContent=label},2400);
      })
      .catch(function(){btn.textContent='No se pudo agregar';setTimeout(function(){btn.disabled=false;btn.textContent=label},2400)});
  },true);
})();
